<div
  class="flex items-center justify-center w-full h-[2.375rem] border border-green text-body-2-bold text-center rounded-lg cursor-pointer transition-all"
  [ngClass]="{
    'bg-green text-white hover:bg-green-dark hover:border-green-dark': isSelected(),
    'bg-white text-green hover:bg-green-50 hover:border-green-dark hover:text-green-dark': !isSelected(),
  }"
>
  <span>{{ content() }}</span>
</div>
